



















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class IconArrowReturn extends Vue {
    @Prop({ required: false }) readonly color?: string;
}
